import { component } from 'picoapp';

import choozy from 'utils/choozy';
import waitToLoad from 'utils/waitToLoad';

export default component(async (node) => {
  const { passwordInput, submitButton } = choozy(node);

  await waitToLoad('zxcvbn');

  const validate = (value) => {
    // eslint-disable-next-line no-undef
    const { score } = zxcvbn(value);

    node.setAttribute('data-password-strength', value.length > 0 ? score + 1 : 0);

    submitButton.disabled = score < 2;
  };

  passwordInput.addEventListener('input', (e) => {
    validate(e.target.value);
  });

  // If the package is loaded after the user starts filling in the password, we need to make sure the password is still checked without relying on the 'input' event
  validate(passwordInput.value);
});
